import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// ANT DESIGN IMPORT
import {
  Layout,
  Button,
  Space,
  Dropdown,
  message,
  Card,
  Divider,
  Spin,
} from "antd";
import { Pie as Pie1 } from "@ant-design/plots";
import { Pie, measureTextWidth } from "@antv/g2plot";

import {
  DownOutlined,
  FolderViewOutlined,
  UserOutlined,
} from "@ant-design/icons";

// PROJECT IMPORTS
import { BOM } from "../../services/definedMethod";
import cnt from "../../services/definedConstant";
import { log } from "@antv/g2plot/lib/utils";

function renderStatistic(containerWidth, text) {
  const textStyleStr = `width:${containerWidth}px;font-size:15px;font-weight:400;line-height:2;`;
  return `<div style="${textStyleStr}">${text}</div>`;
}

export const PieChart = (props) => {
  const navigate = useNavigate();
  const [isloading, setIsLoading] = useState(false);

  const {
    data,
    icon,
    labelTop,
    navigateLink,
    isDropDownBtn,
    itemsDropdown = [],
  } = props;

  useEffect(() => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    const containerWidth = "100%"; // Specify the desired width for the pie chart
    const containerHeight = 200; // Specify the desired height for the pie chart

    const piePlot = new Pie(labelTop, {
      appendPadding: 0,
      data,
      angleField: "value",
      colorField: "type",
      radius: 1,
      innerRadius: 0.64,
      width: containerWidth, // Set the width of the chart
      height: containerHeight, // Set the height of the chart
      meta: {
        value: {
          formatter: (v) => `${v} #`,
        },
      },
      label: {
        type: "inner",
        offset: "-50%",
        style: {
          textAlign: "center",
        },
        autoRotate: false,
        content: "{value}",
        // content: BOM.formatNumber("{value}"),
      },
      statistic: {
        title: {
          offsetY: -4,
          customHtml: (container, view, datum) => {
            const d = Math.sqrt(
              Math.pow(containerWidth / 2, 2) + Math.pow(containerHeight / 2, 2)
            );
            const text = datum ? datum.type : "Total";
            return renderStatistic(d, text);
          },
        },
        content: {
          offsetY: 4,
          style: {
            fontSize: "32px",
          },
          customHtml: (container, view, datum, data) => {
            const text = datum
              ? `${BOM.formatNumber(datum.value)}`
              : `${data.reduce((r, d) => r + d.value, 0)}`;
            return renderStatistic(containerWidth, text);
          },
        },
      },
      interactions: [
        { type: "element-selected" },
        { type: "element-active" },
        { type: "pie-statistic-active" },
      ],
    });

    piePlot.render();

    // Cleanup function to destroy the chart when the component unmounts
    return () => {
      piePlot.destroy();
    };
  }, []); // Empty dependency array ensures this effect runs once after the initial render

  //drop down
  const handleMenuClick = (objParam) => {
    const item = itemsDropdown?.find((element) => element.key === objParam.key);
    navigate(item.route);
  };

  const menuProps = {
    items: itemsDropdown,
    onClick: handleMenuClick,
  };

  const viewCustomer = () => {
    if (!BOM.HasPermission("READ_CLIENT")) {
      BOM.AlertMsg(cnt.WARNING, "Insufficient privileges to access this page");
    } else {
      navigate(`/${navigateLink}`);
    }
  };
  return (
    <Spin spinning={isloading}>
      <Card
        bordered={true}
        style={{
          marginBottom: 16,
          borderRadius: "50px",
          boxShadow: "0 6px 6px -3px var(--of-dark-purple)",
        }}
        hoverable={true}
      >
        <div
          style={{ fontWeight: "bold", fontSize: 18, margin: 0, padding: 0 }}
        >
          {icon}
          &nbsp; {data.length > 1 ? `${labelTop}s` : labelTop}
        </div>
        <Divider />
        <div id={labelTop} />
        <Divider />

        {isDropDownBtn ? (
          <Dropdown menu={menuProps}>
            <Button
              className="of-primaryBtnColor"
              shape="round"
              icon={<FolderViewOutlined />}
            >
              <Space>
                VIEW
                <DownOutlined />
              </Space>
            </Button>
          </Dropdown>
        ) : (
          <Button
            className="of-primaryBtnColor"
            shape="round"
            // size="small"
            onClick={viewCustomer}
            icon={<FolderViewOutlined />}
          >
            VIEW ALL
          </Button>
        )}
      </Card>
    </Spin>
  );
};
